import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "@/components/admin/header/PageHeader";
import UserEditForm from "@/components/admin/userManagement/UserEditForm";
import { routes } from "@/configs/router.config/routes";
import { useUser } from "@/hooks/useUser";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { Role } from "@/models/user";
import { showError, showSuccess } from "@/utils/notification";

const UserEditPage: React.FC = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const { currentWorkspaceId } = useWorkspaces();

  const { user, isLoading, updateUser } = useUser(id);

  if (!id) return <></>;

  const submit = async (email: string, name: string, role: Role, phoneNumber?: string) => {
    if (user?.email !== email) return;

    try {
      await updateUser(user.id, name, role, phoneNumber);
      showSuccess("ユーザー情報を更新しました。");
      navigate(routes.userList(currentWorkspaceId));
    } catch (error) {
      console.error(error);
      showError("更新に失敗しました。");
    }
  };

  return (
    <>
      <PageHeader hasBack title="ユーザー編集" />

      <UserEditForm
        submit={submit}
        isLoading={isLoading}
        isUpdate
        user={user}
      />
    </>
  );
};

export default UserEditPage;
